import MobileAppBanner from './MobileAppBanner';

export default MobileAppBanner;
